import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  Box,
  Button,
  useMediaQuery,
  IconButton,
  ListItemButton,
  List,
  ListItemText,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import joinBGRight from "../images/join-bg-right.jpg";
import targetImage from "../images/home_bg.jpg";
import caseStudiesBg from "../images/case_studies_bg.jpg";
import { Assignment } from "@mui/icons-material";
import sharifHome2 from "../images/sharifHome2.jpg";
import EmailSignupModal from "./EmailSignupModal";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import logo512 from "../images/sharifLogo.jpg";
import XIcon from "@mui/icons-material/X";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  testimonialSection: {
    padding: theme.spacing(8, 0),
    textAlign: "center",
  },
  testimonial: {
    padding: theme.spacing(2),
    position: "relative",
    "&:before": {
      content: '"\\201c"',
      fontFamily: '"Times New Roman", Times, serif',
      display: "block",
      fontSize: "72px",
      lineHeight: "50px",
      fontWeight: 700,
      textAlign: "left",
      position: "static",
      color: "#FFFFFF",
    },
  },
  servicesSection: {
    textAlign: "center",
  },
  caseStudiesSection: {
    backgroundImage: `url(${caseStudiesBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    padding: theme.spacing(8, 2),
    textAlign: "left",
  },
}));

const Home = () => {
  const [showDonate, setShowDonate] = useState(false);
  const location = useLocation();
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isPrioritiesPage = location.pathname === "/priorities";
  const [emailOpen, setEmailOpen] = useState(false);
  const isHomePage = location.pathname === "/";

  // useEffect(() => {
  //   if (isHomePage) {
  //     const hasSeenPopup = localStorage.getItem("emailPopupSeen");

  //     if (!hasSeenPopup) {
  //       setTimeout(() => {
  //         setEmailOpen(true);
  //         localStorage.setItem("emailPopupSeen", "true");
  //       }, 2500); // load delay
  //     }
  //   }
  // }, [isHomePage]);

  // useEffect(() => {
  //   if (isMobile) {
  //     setShowDonate(true);
  //   } else {
  //     const handleScroll = () => {
  //       setShowDonate(window.scrollY > 100);
  //     };
  //     window.addEventListener("scroll", handleScroll);
  //     return () => window.removeEventListener("scroll", handleScroll);
  //   }
  // }, [isMobile]);

  return (
    <Box sx={{ backgroundColor: "#106cb7!important" }}>
      <Box
        className={classes.header}
        sx={{
          backgroundImage: isPrioritiesPage ? "none" : `url(${targetImage})`,
          backgroundColor: isPrioritiesPage ? "#0073e6" : "transparent",
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
          height: isPrioritiesPage ? "200px" : isMobile ? "auto" : "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: isPrioritiesPage ? "2rem" : "8rem",
          textAlign: "center",
        }}
      >
        {isMobile && (
          <Box
            sx={{
          
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              position: "relative",
              top: "4rem",
              left: "1rem",
              padding: "8px",
              background: "transparent",
            }}
          >
            <img
              src={logo512}
              alt="Sharif Hidayat Logo"
              style={{
                borderRadius: ".5rem",
                background: "white",
                padding: ".25rem",
                boxShadow:
                  "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
                maxWidth: "200px",
              }}
            />
          </Box>
        )}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100vh",
            width: "38vw",
            zIndex: 10,
            textAlign: "center",
            color: "white",
            display: isMobile ? "none" : "auto",
            px: 2,
          }}
        >
          {" "}
          {/* Top Tagline */}{" "}
          <Typography
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
              fontSize: { xs: "2.5rem", sm: "3.5rem" },
            }}
          >
            {" "}
            Support{" "}
          </Typography>
          {/* Main Headline */}{" "}
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "2.5rem", sm: "3.5rem" },
              lineHeight: 1.1,
              maxWidth: "90vw",
              mb: 3,
            }}
          >
            {" "}
            Sharif Hidayat<br></br>
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1.25rem", sm: "1.25rem" },
              lineHeight: 1.1,
              maxWidth: "90vw",
              mb: 3,
            }}
          >
            {" "}
            Montgomery County Council, District 7{" "}
          </Typography>
          <form
            action="https://api.web3forms.com/submit"
            method="POST"
            style={{ width: "100%" }}
          >
            {" "}
            <input
              type="hidden"
              name="access_key"
              value="cbee500a-aca1-424f-b45b-51aa780c842e"
            />
            <Grid container spacing={1} justifyContent="center" mb={1}>
              {" "}
              <Grid item>
                {" "}
                <TextField
                  variant="filled"
                  placeholder="Email Address"
                  name="email"
                  type="email"
                  required
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 300,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />{" "}
              </Grid>{" "}
              <Grid item>
                {" "}
                <TextField
                  variant="filled"
                  placeholder="Zip"
                  name="zip"
                  required
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 200,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />{" "}
              </Grid>{" "}
            </Grid>
            <Grid container spacing={1} justifyContent="center">
              {" "}
              <Grid item>
                {" "}
                <TextField
                  variant="filled"
                  placeholder="Phone Number"
                  name="phone"
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 300,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />{" "}
              </Grid>{" "}
              <Grid item>
                {" "}
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    height: 56,
                    backgroundColor: "#014991",
                    borderRadius: 0,
                    width: 200,
                    px: 4,
                    fontWeight: "bold",
                    fontSize: "1rem",
                    "&:hover": { backgroundColor: "#cc8500" },
                  }}
                >
                  {" "}
                  JOIN{" "}
                </Button>{" "}
              </Grid>{" "}
            </Grid>
          </form>
          {/* Disclaimer */}{" "}
          <Typography
            variant="caption"
            sx={{ maxWidth: 500, opacity: 0.7, mt: 2, fontSize: "0.75rem" }}
          >
            {" "}
            By providing your cell phone number you consent to receive recurring
            donation & campaign updates.{" "}
          </Typography>{" "}
        </Grid>

        <Grid container justifyContent="center">
          <Typography
            variant="h2"
            sx={{
              color: "#FFFFFF",
              fontSize: isPrioritiesPage ? "2.5rem" : "4rem",
              fontWeight: 700,
            }}
          >
            {isPrioritiesPage ? "Priorities" : ""}
          </Typography>
        </Grid>
      </Box>

      {/* ABOUT SHARIF Section */}
      <Grid
        id="meet-sharif"
        container
        display="flex"
        justifyContent="center"
        px={6}
        py={12}
        flexDirection="column"
        sx={{
          background: `#014991!important`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: isMobile ? "2rem 0" : "6rem 3rem",
          color: "#fff",
        }}
        alignItems="center"
      >
        {/* {showDonate && (
          <Grid className="donate-top">
            <List>
              <ListItemButton
                component="a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemText primary="DONATE" />
              </ListItemButton>
            </List>
          </Grid>
        )} */}

        {/* Sharif Description */}
        <Grid
          container
          display="flex"
          flexDirection="row"
          justifyContent="center"
        >
          <Grid
            item
            display="flex"
            flexDirection="column"
            xs={12}
            md={6}
            my={isMobile ? 2 : 0}
            sx={{borderRadius: ".5rem"}}
          >
            <img
              src={sharifHome2}
              alt="Sharif community"
              style={{
                width: "100%",
                borderRadius: "16px!important",
                marginBottom: "1rem",
                padding: isMobile ? "1rem" : "4rem",
              }}
            />
          </Grid>
          <Grid container md={6} justifyContent="center">
            <Grid
              item
              display="flex"
              flexDirection="column"
              justifyContent="center"
              lg={8}
              px={4}
              sx={{
                fontStyle: "normal",
                fontWeight: "500",
                maxWidth: !isMobile ? "50vw" : "auto",
                fontSize: "1.25rem",
                lineHeight: "1.6875",
                fontFamily: "'Open Sans', sans-serif",
                letterSpacing: "0em",
                textAlign: "left",
                color: "#FFFFFF",
                mb: 2,
              }}
            >
              <Typography variant="p">
                "I am running for County Council to represent you – Not the
                developers or special interests. And that’s why I am funding my
                own campaign. To represent ONLY you. I promise to fight every
                day for YOUR priorities – better schools, safer neighborhoods,
                protecting open space, smarter growth and lower property taxes.
                I will end putting the special interests ahead of yours."{" "}
                <br></br>
                <br></br>Sharif Hidayat
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Volunteer Section */}
      <Grid
        container
        flexDirection="row"
        sx={{ background: "#FFFDF7!important" }}
      >
        <Grid
          id="learn-more-deb"
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{ minHeight: "300px" }}
          md={12}
        >
          <Grid item sx={volunteerHeaderStyle(isMobile)}>
            <Typography variant="h3">Join Sharif's Team</Typography>
          </Grid>

          <Grid item sx={volunteerButtonStyle(isMobile)}>
            <Button
              startIcon={
                <Assignment
                  sx={{ fontSize: "5rem!important", color: "white" }}
                />
              }
              sx={{
                padding: "1rem 2rem",
                color: "white!important",
                background: "#014991!important",
                border: "1px solid white",
                boxShadow:
                  "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
              }}
              href="https://docs.google.com/forms/d/1kW751kMXg1Cvjeq4PpGNXS4BAddEvivJMuCWnpNhtmU/edit"
              target="_blank"
            >
              <Typography variant="h3" sx={{ color: "white!important" }}>
                Volunteer Today!
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          pb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setEmailOpen(true)}
              sx={{
                textTransform: "none",
                background: "#FFFDF7!important",
                color: "#014991!important",
              }}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/SharifHidayat320/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            {/* <IconButton
              component="a"
              href="https://x.com/votesharif2026"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton> */}
            <IconButton
              component="a"
              href="https://facebook.com/VoteSharifDistrict7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By authority: Friends of Sharif Hidayat; Cody Hidayat, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};

const volunteerHeaderStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  fontSize: "16px",
  lineHeight: "1.6875",
  fontFamily: "'Open Sans', sans-serif",
  textAlign: "center",
  color: "#106cb7!important",
  mt: 2,
  mb: 4,
  px: 2,
});

const volunteerButtonStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  mt: 2,
  mb: 2,
  px: 2,
});

const volunteerFooterStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  mt: 2,
  mb: 2,
  px: 2,
  fontSize: "8px",
  lineHeight: "1.6875",
  textAlign: "center",
  border: "1px solid #106cb7!important",
  borderRadius: ".25rem",
  color: "#106cb7!important",
});

export default Home;
